import ApiService from 'services/ApiService';
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  lists: [],
  error: null
};

const slice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    hasError(state, action) {
      state.error = action.payload;
    },
    getLists(state, action) {
      state.lists = action.payload;
    },
    getProductionTotalQty(state, action) {
      state.lists = action.payload;
    }
  }
});

export const { getLists, getProductionTotalQty } = slice.actions;
export default slice.reducer;

export function getDashboardProductionTotalQty() {
  return async (dispatch) => {
    try {
      const response = await ApiService.get({ path: '/dashboard/productionTotalQty' });
      dispatch(slice.actions.getProductionTotalQty(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.message || 'An error occurred'));
    }
  };
}

export function getDashboardList() {
  return async (dispatch) => {
    try {
      const response = await ApiService.get({ path: '/dashboard/list' });
      dispatch(slice.actions.getLists(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.message || 'An error occurred'));
    }
  };
}
